import { confirm } from './util';

$(document).on('submit', 'form[data-confirm]', function(event) {
  event.preventDefault();
  const $this = this;

  confirm($this).then(({ confirmed, reveal }) => {
    if (confirmed) {
      reveal.addClass('loading');
      $this.submit();
    }
  }).catch(() => {});
});
